"use client";

import Link from "next/link"
import { useEffect } from "react"

export function Footer() {
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const btn = (e.target as HTMLElement).closest('[data-legal-modal]');
      if (btn) {
        const type = btn.getAttribute('data-legal-modal');
        window.dispatchEvent(new CustomEvent('open-legal-modal', { detail: type }));
      }
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and description */}
          <div className="space-y-4">
            <img src="/Revvu-Logo-Dark.svg" alt="revvu logo" className="h-8 w-auto" />
            <p className="text-gray-400">
              Track revenue from all your channels in one place. Built for creators, by creators.
            </p>
          </div>

          {/* Product */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Product</h4>
            <div className="space-y-2">
              <a href="#" className="block text-gray-400 hover:text-white transition-colors" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                Features
              </a>
              <Link href="/pricing" className="block text-gray-400 hover:text-white transition-colors">
                Pricing
              </Link>
              <Link href="/auth/signin" className="block text-gray-400 hover:text-white transition-colors">
                Login
              </Link>
            </div>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Support</h4>
            <div className="space-y-2">
              {/* <Link href="#" className="block text-gray-400 hover:text-white transition-colors">
                Help Center
              </Link> */}
              <a href="mailto:creativecollectivepgh@gmail.com" className="block text-gray-400 hover:text-white transition-colors">
                Contact Us
              </a>
              {/* <Link href="#" className="block text-gray-400 hover:text-white transition-colors">
                API Docs
              </Link> */}
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Legal</h4>
            <div className="space-y-2">
              <button
                type="button"
                className="block text-gray-400 hover:text-white transition-colors w-full text-left"
                data-legal-modal="privacy"
              >
                Privacy Policy
              </button>
              <button
                type="button"
                className="block text-gray-400 hover:text-white transition-colors w-full text-left"
                data-legal-modal="terms"
              >
                Terms and Conditions
              </button>
              <button
                type="button"
                className="block text-gray-400 hover:text-white transition-colors w-full text-left"
                data-legal-modal="cookie"
              >
                Cookie Policy
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">© 2025 revvu. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
